import {
  CampaignCreatePageKey,
  CampaignListPageKey,
  CampaignListTableKey,
  CampaignReviewPageKey,
  ReferralAnalyticsKey,
  ReferralReportsKey,
  ReferralRewardModeKey,
  ReferralTierLadderKey
} from '../../TModules';

export const translations = {
  [CampaignListPageKey]: {
    Title: 'Campagnes',
    Label: 'Créer une nouvelle'
  },

  [CampaignListTableKey]: {
    All: 'Tout',
    Draft: 'Brouillon',
    Pending: 'En attente',
    Scheduled: 'Programmé',
    Active: 'Actif',
    Ended: 'Terminé',
    Inactive: 'Inactif',
    SearchPlaceholder: 'Rechercher une campagne par nom ou identifiant',
    FilterBy: 'Filtrer par',

    // Game Types
    TapWin: 'Tapez & gagnez',
    CollectWin: 'Collectez & gagnez',
    ShakeTheTree: "Secouez l'arbre",
    HitThePinata: 'Frappez la Piñata',
    SpinTheWheel: 'Tournez la roue',
    Plinko: 'Plinko',
    MysteryBox: 'Boîte mystère',
    ScratchCard: 'Carte à gratter',

    OnDeactivateErrorMessage: 'Erreur lors de la désactivation de la campagne',
    OnApproveErrorMessage: "Erreur lors de l'approbation de la campagne",
    OnMoveRowErrorMessage: 'Erreur lors du tri de la campagne.',

    Approve: 'Approuver',
    Review: 'Examiner',
    Edit: 'Modifier',
    Activate: 'Activer',
    Deactivate: 'Désactiver',
    Duplicate: 'Dupliquer',
    UploadTries: 'Télécharger les essais',
    MoveToTop: 'Déplacer en haut',
    ApproveCampaign: 'Approuver la campagne',

    Name: 'Nom',
    Type: 'Type',
    Status: 'Statut',
    StartDate: 'Date de début',
    EndDate: 'Date de fin',
    Request: 'Demande',
    Comments: 'Commentaires',
    Actions: 'Actions',
    AllGames: 'Tous les jeux',
    ApproveRequests: 'Approuver les demandes',

    ApproveMultipleMessageModal: {
      MultipleApproveRequestSuccessMessage: 'Les demandes ont été approuvées',
      SuccessMessage: 'Campagnes approuvées',
      ErrorMessage: "Erreur lors de l'approbation des campagnes.",
      Title: 'Approuver plusieurs demandes ?',
      OkText: 'Approuver la sélection',
      DescriptionLineOne: 'Êtes-vous sûr de vouloir approuver toutes les demandes sélectionnées ?',
      DescriptionLineTwo:
        "Veuillez vérifier les détails avant d'approuver car cette action ne peut pas être annulée.",
      ErrorApprovingRewards: "Erreur lors de l'approbation des récompenses."
    },

    ApproveMessageModal: {
      SuccessMessage: 'La demande a été approuvée',
      FailureMessage: "Erreur lors de l'approbation de la campagne.",
      Title: 'Approuver la campagne ?',
      OkText: 'Approuver',
      DescriptionLineOne: 'Êtes-vous sûr de vouloir approuver cette campagne ?',
      DescriptionLineTwo: 'Cette action ne peut pas être annulée.'
    },

    CampaignType: {
      AllCampaigns: 'Toutes les campagnes',
      InstantReward: 'Récompense instantanée',
      Stamp: 'Stempel',
      Referral: 'Référence',
      Game: 'Jeu',
      Reward: 'Récompense',
      Quiz: 'Quiz',
      Survey: 'Enquête',
      Quest: 'Quest',
      Progress: 'Progression',
      Raffle: 'Tirage au sort',
      MultipleRuleCampaign: 'Campagne à règles multiples'
    }
  },

  [CampaignCreatePageKey]: {
    DuplicatingCampaign: 'Duplication de la campagne...',
    OnSubmitErrorMessage: 'Aucune modification détectée',
    StreakModeIsRequired: 'Le mode série est requis',
    StreakTargetIsRequired: 'L’objectif de série est requis',
    StreakTargetCriteriaIsRequired: 'Les critères de l’objectif de série sont requis',
    StreakDurationIsRequired: 'La durée de la série est requise',
    Steps: {
      TaskType: 'Type de tâche',
      Back: 'Retour',
      Cancel: 'Annuler',
      Next: 'Suivant',
      SaveAsDraft: 'Enregistrer comme brouillon',
      Publish: 'Publier',
      Save: 'Enregistrer',
      Deactivate: 'Désactiver',
      Schedule: 'Planifier',

      Info: 'Info',
      SelectAudience: "Sélectionner l'audience",
      Mechanics: 'Mécaniques',
      StreakMode: 'Mode série',
      StreakTargetAndPrizes: 'Objectif de série et prix',
      Review: 'Révision',
      DetailedTitle: {
        Info: 'Informations de la campagne',
        SelectAudience: "Sélectionner l'audience",
        Mechanics: 'Mécaniques',
        Review: 'Révision'
      },
      ViewInsights: 'Afficher les insights',
      Edit: 'Modifier',
      Loading: 'Chargement'
    },

    CampaignInfo: {
      Title: 'Détails de la campagne',
      Form: {
        Name: 'Nom',
        NamePlaceholder: 'Veuillez saisir le nom de votre campagne',
        Subtitle: 'Sous-titre',
        SubtitlePlaceholder: 'Veuillez saisir le sous-titre de votre campagne',
        ContentSuggestions: 'Suggestions de contenu',
        ShowChatGPTForm: {
          TooltipTitle:
            'Les limites de jetons se renouvellent quotidiennement. Devenez membre exclusif Perx pour des jetons illimités',
          TokensLeft: 'jetons restants'
        },
        Description: 'Description',
        TermsAndConditions: 'Conditions générales',
        RiskDisclaimer: 'Avertissement sur les risques',

        CampaignDuration: 'Durée de la campagne',
        StartDate: 'Date de début',
        EndDate: 'Date de fin',
        EarlyDisplayCampaign: 'Commencer à afficher la campagne',
        DaysBeforeStartDate: 'jours avant la date de début',
        DaysBeforeTheStartDate: 'jours avant la date de début',
        CampaignDoesNotEnd: 'La campagne ne se termine pas',
        ShouldHideDurationEndDateAlertMessage:
          'Les campagnes de tirage au sort nécessitent une date de fin',
        EndDateAlertMessage: 'La date de fin doit être égale ou postérieure à la date de début',

        Reset: 'Réinitialiser',
        OCBCDemo: {
          Never: 'Jamais',
          Weekly: 'Hebdomadaire',
          Monthly: 'Mensuel',
          Yearly: 'Annuel'
        },

        ActiveAt: 'Actif à',
        ActiveAtMessage: "La campagne ne s'active pas avant la date de début",

        Tags: 'Tags',
        Categories: 'Catégories',
        Labels: 'Étiquettes',
        Catalogues: 'Catalogues',
        Owner: 'Propriétaire',
        PleaseSelectAnOwner: 'Veuillez sélectionner un propriétaire',

        UploadPhoto: 'Télécharger une photo',
        UploadMultipleImages: 'Télécharger plusieurs images',
        Merchant: 'Marchand',
        MerchantSelectPlaceholder: 'Veuillez sélectionner un marchand',
        Locations: 'Lieux',
        LocationsSelectPlaceholder: 'Veuillez sélectionner des lieux',
        CustomFields: 'Champs personnalisés',
        CustomField: 'Champ personnalisé',
        CustomFieldNamePlaceholder: 'Veuillez saisir le nom du champ',
        CustomFieldValuePlaceholder: 'Veuillez saisir la valeur du champ',
        AddCustomField: 'Ajouter un champ personnalisé'
      },

      TagSelect: 'Veuillez sélectionner vos tags',
      CategorySelect: 'Veuillez sélectionner vos catégories',
      LabelSelect: 'Veuillez sélectionner vos étiquettes',
      CatalogueSelect: 'Veuillez sélectionner vos catalogues'
    },

    ButtonWithImageUpload: {
      Cancel: 'Annuler',
      InsertPhoto: 'Insérer une photo',
      UploadFile: 'Télécharger un fichier',
      ChooseFile: 'Choisir un fichier',
      ChooseAFile: 'Choisir un fichier',
      SelectPngSvgJpegGif: 'Sélectionner PNG, SVG, JPEG ou GIF'
    },

    CampaignSelectAudience: {
      SelectAudience: 'Sélectionner une audience',
      DefaultAudience: 'Créer une audience à usage unique pour cette campagne',
      ExistingAudience: 'Sélectionner une audience existante',
      AudienceSetup: "Paramètres de l'audience",
      SelectFilters: 'Sélectionner des filtres',
      SelectedFilters: 'Filtres sélectionnés',

      AudienceListSetup: {
        Include: 'Inclure',
        Exclude: 'Exclure',
        AudienceExistsMessage: `Ne peut pas {{audienceIncludeExclude}} audience qui est déjà définie pour {{audienceIncludeExcludeNoun}}`,
        PickAudienceList: "Choisir une liste d'audience",

        Includes: 'Inclus',
        Excludes: 'Exclus',
        AudienceWarningMessage:
          "Le fichier de l'audience téléchargé ne sera traité que lorsqu'il aura été approuvé par un approbateur d'actions en bloc",
        SelectedFileForInclusion: "Fichier sélectionné pour l'inclusion",
        AudienceNotInTheList: 'Audience non dans la liste',
        IncludeAudienceFilenamePlaceholder: "Nom de la liste d'inclusion d'audience",
        UploadNow: 'Télécharger maintenant',
        UploadNewList: 'Télécharger une nouvelle liste',
        AcceptedFormat: 'Format accepté: fichiers .xlsx/.csv uniquement.',
        DownloadSample: 'Télécharger un exemple',
        UploadExclusion: "Télécharger l'exclusion",
        SelectedFileForExclusion: "Fichier sélectionné pour l'exclusion",
        ExcludeAudienceFilenamePlaceholder: "Nom de la liste d'exclusion d'audience"
      },

      AudienceFilters: {
        Age: 'Âge',
        BirthMonth: 'Mois de naissance',
        Gender: 'Sexe',
        Location: 'Localisation',
        Loyalty: 'Fidélité',
        Personal: 'Personnel',
        Custom: 'Personnalisé',
        EmailTags: 'Tags email',
        Ethnicity: 'Ethnie',
        SelectCustomerAttributeFilters: 'Sélectionner vos filtres de client',
        NoFiltersSelected: 'Aucun filtre sélectionné',

        And: 'et',
        Badge: 'Badge',
        Campaign: 'Campagne',
        Leaderboard: 'Classement',
        LoyaltyPoints: 'Points de fidélité',
        LoyaltyTier: 'Niveau de fidélité',
        MemberSince: 'Membre depuis',
        Reward: 'Récompense',
        PaymentBased: 'Basé sur le paiement',
        Payment: 'Paiement',
        SelectFilters: "Sélectionner des filtres pour générer automatiquement une liste d'audience",
        City: 'Ville',
        States: 'États',

        OfferId: "ID de l'offre",
        PrimaryClusterComb: 'Combinaison de cluster primaire',
        PrimaryClusterState: 'État du cluster primaire',
        Membership: 'Membre de',
        CurrentBirthday: 'Uniquement le jour de naissance',
        CurrentBirthMonth: 'Uniquement pendant le mois de naissance',
        HasBirthday: "Jour d'anniversaire",
        UserType: "Type d'utilisateur",
        AccountConfirmedAt: 'Inscrit entre',
        LoyaltyPointsBalance: 'Solde de points',
        CampaignEnrolment: 'Campagne',
        LeaderboardPosition: 'Position au classement',
        UPI: 'UPI',
        ScanPay: 'Paiement par scan',
        BBPS: 'BBPS',
        KYC: 'KYC',
        CurrentAddress: 'Adresse actuelle',
        PaymentStatus: 'Statut du paiement',
        DaysPastDues: 'Jours de retard',
        BNPLUnpaidEMIDate: 'Date EMI impayée BNPL',
        InstaloanUnpaidEMIDate: 'Date EMI impayée Instaloan',

        AgeFilter: {
          Title: 'Âge',
          Includes: 'Inclus',
          Excludes: 'Exclus',
          SelectPlaceholder: 'Inclus',
          From: 'âges de',
          FromPlaceholder: '18',
          To: 'à',
          ToPlaceholder: '35',
          AddRange: 'Ajouter une plage',
          And: 'et'
        },
        BirthdayFilter: {
          Title: 'Anniversaire',
          SelectBirthMonth: 'Sélectionner le mois de naissance',
          BirthMonth: 'Mois de naissance',
          CurrentBirthMonth: 'Mois de naissance actuel',
          OnlyDuringMonthOfBirth: 'Uniquement pendant le mois de naissance',
          HasBirthday: 'A son anniversaire',
          OnBirthday: 'Le jour de son anniversaire',
          Includes: 'Inclus',
          Excludes: 'Exclus'
        },
        GenderFilter: {
          Title: 'Genre',
          SelectByGender: 'Sélectionner par genre',
          Male: 'Homme',
          Female: 'Femme'
        },
        EthnicityFilter: {
          Title: 'Ethnicité',
          SelectEthnicity: "Sélectionner l'ethnicité",
          SelectEthnicityPlaceholder: "Sélectionner l'ethnicité",
          Include: 'Inclure',
          Exclude: 'Exclure',
          Includes: 'Inclus',
          Excludes: 'Exclus'
        },
        LocationFilter: {
          Title: 'Localisation',
          SelectCity: 'Sélectionner la ville',
          Include: 'Inclure',
          Exclude: 'Exclure',
          SelectCityPlaceholder: 'Sélectionner les villes',
          SelectState: "Sélectionner l'état",
          SelectStatePlaceholder: "Sélectionner l'état",
          Includes: 'Inclus',
          Excludes: 'Exclus'
        },

        PersonalFilter: {
          Title: 'Personnel',
          HubClub: 'Hub Club',
          Select: 'Sélectionner',
          Include: 'Inclure',
          Exclude: 'Exclure',
          AddCustomProperties: 'Ajouter des propriétés personnalisées',
          EnterKeyNameAndValueDetails: 'Entrer le nom de la clé et les détails de la valeur',
          SelectRelation: 'Sélectionner la relation',
          EnterNumber: 'Entrer un nombre',
          KeyValue: 'Valeur de la clé',
          DatePlaceholder: 'JJ-MM-AAAA',
          KeyNamePlaceholder: 'Nom de la clé',
          Is: 'Est',
          True: 'Vrai',
          False: 'Faux',
          And: 'ET',
          Or: 'OU',
          CustomAttributeType: 'Type de champ personnalisé #{{index}}',
          CustomAttribute: 'Champ personnalisé #{{index}}',
          CustomAttributeOperator: 'Opérateur de champ personnalisé #{{index}}',
          CustomAttributeValue: 'Valeur du champ personnalisé #{{index}}'
        },

        LoyaltyFilter: {
          Title: 'Fidélité',
          SelectLoyaltyProgram: 'Sélectionner le programme de fidélité',
          Include: 'Inclure',
          Exclude: 'Exclure',
          SelectProgram: 'Sélectionner le programme',
          Includes: 'Inclus',
          Excludes: 'Exclus',
          UsersWithPointsBalance: 'Utilisateurs avec solde de points',
          SelectLoyaltyProgramPlaceholder: 'Sélectionner le programme de fidélité',
          From: 'De',
          To: 'À',
          PointsBalanceFrom: 'Solde de points de',
          PointsBalanceTo: 'à'
        },

        EmailTagsFilter: {
          Includes: 'Inclut',
          SelectEmailTags: 'Sélectionner les tags email',
          Excludes: 'Exclut'
        }
      }
    },

    SocialMediaFields: {
      Title: 'Réseaux sociaux',
      OGTitle: 'Titre',
      OGDescription: 'Description',
      OGImage: 'Image',
      OGImageAlt: 'Aperçu réseaux sociaux',
      IOSAppLink: 'Lien App iOS',
      AndroidAppLink: 'Lien App Android',
      WebLink: 'Lien Web',

      EitherAnIOSOrAndroidOrWebLinkIsRequired: 'Un lien iOS, Android ou Web est requis',
      Allowed: 'Format accepté: .jpg, .png, .svg',
      Browse: 'Parcourir',
      Recommended: 'Recommandé: 720px par 120px'
    },

    CampaignMechanics: {
      CampaignType: 'Type de campagne',
      InstantReward: 'Récompense instantanée',
      MultipleRuleCampaign: 'Campagne à règles multiples',
      Reward: 'Récompense',
      Progress: 'Progression',
      Raffle: 'Tirage au sort',
      Stamp: 'Tampon',
      Game: 'Jeu',
      Quest: 'Quête',
      Referral: 'Parrainage',
      Survey: 'Sondage',
      Quiz: 'Quiz',
      Streak: 'Série',
      GameTry: 'Essai de jeu',
      Day: 'jour',
      GiveRewardTitle: 'Émission instantanée de toutes les récompenses',
      Yes: 'Oui',
      No: 'Non'
    },

    CampaignReferralGameTryModal: {
      SelectCampaigns: 'Sélectionner les campagnes',
      SetupReferralRule: 'Configurer la règle de parrainage',
      NumberOfGameTry: "Nombre d'essais de jeu",
      WarningText:
        "Seules les campagnes avec l'émission automatique d'essais de jeu désactivée peuvent être sélectionnées pour l'émission d'essais de jeu.",
      CampaignID: 'ID Campagne: {{id}}, {{name}}',
      Back: 'Retour',
      Next: 'Suivant',
      Done: 'Terminé',
      SearchCampaigns: 'Rechercher des campagnes',
      Active: 'Actif',
      Scheduled: 'Planifié',
      Referee: 'Filleul',
      Referrer: 'Parrain',
      NoOfReferralsNeeded: 'Nombre de parrainages requis'
    },

    Outcomes: {
      SelectOutcomes: 'Sélectionner les résultats',
      Name: 'Nom',
      Action: 'Action',
      EditPoints: 'Modifier les points',
      Remove: 'Supprimer',
      EditReferralRule: 'Modifier la règle de parrainage',
      MoveToTop: 'Déplacer en haut',
      MerchantName: 'Nom du marchand',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à",
      RewardBalance: 'Solde de récompense',
      PointsAwarded: 'Points attribués',
      ReferrerLimits: 'Limites du parrain',
      ReferralsNeeded: 'Parrainages nécessaires',
      RefereeRewardLimit: 'Limite de récompense du filleul',
      AwardBadges: 'Attribuer des badges',
      AwardPoints: 'Attribuer des points',
      AddRewards: 'Ajouter des récompenses',
      AwardGameTry: 'Attribuer un essai de jeu',
      EditGameTry: "Modifier l'essai de jeu",
      ReferrerGameTryIssued: 'Essai de jeu Parrain',
      RefereeGameTryIssued: 'Essai de jeu Filleul'
    },

    CampaignRules: {
      AddRule: 'Ajouter une règle'
    },

    RefferalSelectionModal: {
      Title: 'Modifier la règle de parrainage',
      OnCancelError: "La valeur de parrainage n'est pas un nombre ! Veuillez vérifier !",
      OkButtonText: 'OK',
      RewardId: 'ID de récompense :',
      Referee: 'Filleul',
      Referrer: 'Parrain',
      NoOfReferralsNeeded: 'Nombre de parrainages nécessaires',
      TotalRewardLimit: 'Limite totale de récompense',
      RewardLimit: 'Limite de récompense',
      RewardBalance: 'Solde de récompense : ',
      CheckboxError: 'Les options Parrain ou Filleul sont requises',
      RewardIDTitle: 'ID de récompense :',
      Points: 'Points',
      Of: ' sur ',
      TotalOutcomeLimit: 'Limite totale de résultat',
      OutcomeLimit: 'Limite de résultat',
      NumberError: 'Cette valeur doit être un nombre',
      RequiredError: 'Cette valeur est requise'
    },

    CampaignReferralRewardPickerModal: {
      SearchRewards: 'Rechercher des récompenses',
      Active: 'Actif',
      Private: 'Privé',
      Approved: 'Approuvé',
      System: 'Système',
      SelectRewards: 'Sélectionner des récompenses',
      Back: 'Retour',
      Next: 'Suivant',
      Done: 'Terminé',
      Name: 'Nom',
      MerchantName: 'Nom du marchand',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à",
      RewardBalance: 'Solde de récompense',
      SetupReferralRule: 'Configurer la règle de parrainage'
    },

    RewardPicker: {
      SelectRewards: 'Sélectionner des récompenses',
      OkButtonText: 'Ajouter des récompenses',
      SearchRewards: 'Rechercher une récompense par nom, type ou marchand',
      Active: 'Actif',
      Private: 'Privé',
      Approved: 'Approuvé',
      System: 'Système',
      Ended: 'Terminé',
      Inactive: 'Inactif',
      Draft: 'Brouillon',
      Name: 'Nom',
      MerchantName: 'Nom du marchand',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à",
      RewardBalance: 'Solde de récompense'
    },

    CampaignReferralPointsModal: {
      PleaseSelectGLAccount: 'Veuillez sélectionner un compte GL',
      PleaseSelectGLAccountTypeAndName: 'Veuillez sélectionner un compte GL, type et nom',
      PleaseSetNumberOfPointsToAward: 'Veuillez définir le nombre de points à attribuer',
      SetPointsToAward: 'Définir les points à attribuer',
      Next: 'Suivant',
      Done: 'Terminé',
      SelectLoyaltyProgram: 'Sélectionner le programme de fidélité',
      HowManyPoints: 'Combien de points ?',
      SelectGLAccount: 'Sélectionner le compte GL',
      SelectGLAccountType: 'Sélectionner le type de compte GL',
      SelectGLAccountName: 'Sélectionner le nom du compte GL',
      SelectGLAccountNamePlaceholder: 'Nom',
      EnterPoints: 'Saisir les points',
      SetupReferralRule: 'Configurer la règle de parrainage'
    },

    GameTypesSelectModal: {
      Title: 'Sélectionner un type de jeu',
      OkButtonText: 'Sélectionner',
      CancelButtonText: 'Annuler',

      ShakeTheTree: {
        Title: "Secouer l'arbre",
        InstructionsLineOne:
          'Engagez les clients avec un défi qui nécessite de secouer le téléphone',
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en secouant l'arbre",
        InstructionsLineFour:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        InstructionsLineFive: 'Idéal pour',
        InstructionsLineSix: '1. Jeu saisonnier'
      },
      HitThePinata: {
        Title: 'Frapper la Piñata',
        InstructionsLineOne: 'Engagez les clients avec un défi qui nécessite de frapper la piñata',
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en frappant la piñata",
        InstructionsLineFour:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        InstructionsLineFive: 'Idéal pour',
        InstructionsLineSix: '1. Jeu saisonnier'
      },
      ScratchCard: {
        Title: 'Carte à gratter',
        InstructionsLineOne:
          'Engagez les clients en les faisant gratter pour gagner des prix excitants',
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en grattant la carte",
        InstructionsLineFour:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        InstructionsLineFive: 'Idéal pour',
        InstructionsLineSix: '1. Jeu saisonnier'
      },
      SpinTheWheel: {
        Title: 'Tourner la roue',
        InstructionsLineOne:
          'Engagez les clients en les faisant tourner la roue pour gagner des prix excitants',
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en tournant la roue",
        InstructionsLineFour:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        InstructionsLineFive: 'Idéal pour',
        InstructionsLineSix: '1. Jeu saisonnier'
      },
      Plinko: {
        Title: 'Plinko',
        InstructionsLineOne:
          "Engagez les clients en les faisant tenter leur chance pour faire tomber la balle dans l'emplacement gagnant",
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en faisant tomber la balle",
        InstructionsLineFour:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        InstructionsLineFive: 'Idéal pour',
        InstructionsLineSix: '1. Jeu saisonnier'
      }
    },

    StreakTypesSelectModal: {
      SelectStreakCampaignType: 'Sélectionner le type de campagne Streak',
      ContinuousLoop: 'Boucle continue',
      Progressive: 'Progressif',
      CheckIn: 'Enregistrement',
      MilestoneBased: 'Basée sur des étapes',
      TransactionCount: 'Nombre de transactions',
      CumulativeSpend: 'Dépense cumulative',
      ContinuousLoopDescription:
        'Gardez les clients engagés en leur faisant accomplir des tâches à plusieurs reprises dans une période fixe, et ils reçoivent une récompense à chaque fois.',
      GameMechanicsTitle: 'Mécanique du jeu',
      ContinuousLoopGameMechanicsLineOne:
        '1. Le jeu est défini pour une période fixe - quotidienne, hebdomadaire ou mensuelle.',
      ContinuousLoopGameMechanicsLineTwo:
        '2. Les utilisateurs doivent accomplir une tâche spécifique plusieurs fois pendant la période. Une fois les tâches terminées, ils reçoivent la récompense, et la campagne redémarre automatiquement pour la période suivante.',
      IfCustomersMissAStreakTheyStartAgainAtTheNextStreakPeriod:
        '3. Si les clients manquent une série, ils recommencent à la période de série suivante.',
      ContinuousLoopIdealForTitle: 'Idéal pour',
      ContinuousLoopIdealForLineOne: '1. Campagnes de connexion quotidienne',

      MilestoneBasedDescription:
        'Définissez des objectifs progressifs pour vos clients afin qu’ils accomplissent des tâches répétées, avec un prix attribué à chaque étape atteinte.',
      MilestoneBasedGameMechanicsTitle: 'Mécanique du jeu',
      MilestoneBasedGameMechanicsLineOne:
        '1. Le jeu est défini avec un intervalle fixe - quotidien, hebdomadaire ou mensuel.',
      MilestoneBasedGameMechanicsLineTwo:
        '2. Le jeu comporte une tâche définie que les utilisateurs doivent effectuer à plusieurs reprises - par ex. : Connexion, transaction spécifique, etc.',
      MilestoneBasedGameMechanicsLineThree:
        '3. Définissez des jalons selon le nombre de tâches à effectuer et le nombre de périodes continues nécessaires.',
      MilestoneBasedGameMechanicsLineFour:
        '4. Les clients reçoivent un prix chaque fois qu’ils atteignent le jalon. S’ils manquent une série, ils recommencent au jalon actuel. Les prix ne sont attribués qu’une seule fois par jalon.'
    },

    TeamsMechanics: {
      Title: "Mécaniques d'équipe",
      Description:
        "Les paramètres des mécaniques d'équipe ne peuvent pas être mis à jour une fois qu'une campagne a été publiée.",
      ActivateTeamMechanics: "Activer les mécaniques d'équipe",
      TeamSize: 'Utilisateurs par équipe',
      LandingScreen: "Écran d'accueil",
      Image: 'Image',
      ImageHelpText: 'Taille min 360(l) x 144(h) px en jpg ou png',
      PreEnrollmentMessage: 'Message pré-inscription',
      StampsEarnMessage: 'Message de gain de tampons',
      GameplayInstructions: 'Instructions de jeu',
      JoinTeamPage: 'Page rejoindre une équipe',
      JoinTeamInfoMessage: "Message d'info pour rejoindre une équipe",
      InviteMemberMessage: "Message d'invitation de membre",
      InviteCodeBlurb: "Texte du code d'invitation",
      CharactersUsed: 'Caractères utilisés',
      Note: 'Note',
      NoteDescriptionOne: 'À la fois le',
      NoteDescriptionTwo: "message d'invitation de membre",
      NoteDescriptionThree: 'et le',
      NoteDescriptionFour: "texte du code d'invitation",
      NoteDescriptionFive:
        'sont utilisés pour générer le "message de partage". Nous n\'avons pas mis de limite à la longueur de ce message - mais gardez à l\'esprit que les messages SMS ont une limite de 160 caractères par message',

      DefaultPreEnrollmentMessagePartOne: 'Créez ou rejoignez une équipe de {{teamSize}} membres',
      DefaultPreEnrollmentMessagePartTwo: 'Vous pouvez créer ou rejoindre 1 équipe.',
      DefaultStampsEarnMessagePartOne: "Gagnez des tampons en faisant l'une des actions suivantes",
      DefaultStampsEarnMessagePartTwo: 'Faire KYC',
      DefaultStampsEarnMessagePartThree: 'Passer aux relevés électroniques',
      DefaultParticipationInfoMessagePartOne:
        "Gagnez des récompenses en faisant l'une des actions suivantes",
      DefaultParticipationInfoMessagePartTwo: 'Faire KYC',
      DefaultParticipationInfoMessagePartThree: 'Passer aux relevés électroniques',
      DefaultTeamCompleteButtonText: 'Vérifier votre progression',
      DefaultTeamCompleteButtonTextStamp: 'Voir vos cartes de tampons',
      DefaultTeamIncompleteButtonText: 'Rejoindre une équipe',
      DefaultTeamIncompleteButtonTextSecondary: 'Créer une équipe',
      DefaultJoinTeamPageDescriptionPartOne:
        "Une équipe n'est considérée comme active que lorsque {{teamSize}} membres se sont engagés à la rejoindre.",
      DefaultJoinTeamPageDescriptionPartTwo:
        'Entrez le code/url dans le champ ci-dessus et cliquez sur rejoindre',
      DefaultJoinTeamPageDescriptionPartThree:
        'Attendez que {{teamSize}} membres se soient engagés',
      DefaultJoinTeamPageDescriptionPartFour: 'Collectez des tampons en équipe',
      DefaultJoinTeamPageDescriptionPartFive: 'Jouez en équipe',
      DefaultJoinTeamPageDescriptionPartSix:
        "Les individus ne peuvent faire partie que d'1 équipe (créée ou rejointe)",
      DefaultInviteMessageDescriptionPartOne: 'Bonjour, rejoignez mon équipe pour',
      DefaultInviteMessageDescriptionPartTwo: ' remplir des cartes de tampons ',
      DefaultInviteMessageDescriptionPartThree: ' jouer à des jeux ',
      DefaultInviteMessageDescriptionPartFour: ' et gagner des prix ensemble !',
      DefaultInviteMessageCodeBlurb: "Utilisez mon code d'équipe :"
    },

    EnrolMechanics: {
      EnrolmentMechanics: "Mécaniques d'inscription",
      AutoEnrolUsers: 'Inscription automatique des utilisateurs',
      EnrollableUntil: "Inscription possible jusqu'au",
      AutoFillStamps: 'Remplissage automatique des tampons',
      EnableCampaignDurationMechanics: 'Activer les mécaniques de durée de campagne',
      UsersMustCompleteTheCampaignWithin: 'Les utilisateurs doivent terminer la campagne dans',
      AutoRedeemOutcome: 'Résultat de rachat automatique',
      Yes: 'Oui',
      No: 'Non'
    },

    StreakMechanics: {
      StreakMechanics: 'Mécanique de série',
      SelectTaskType: 'Sélectionner le type de tâche',
      CumulativeSpend: 'Dépense cumulative',
      TransactionCount: 'Nombre de transactions',
      SignIn: 'Connexion',
      StreakRequirements: 'Exigences de série',
      TargetCriteria: 'Critères cibles',
      UserMustPerformTheTask: "L'utilisateur doit effectuer la tâche",
      TimesWithinOne: 'fois dans 1',
      StreakTarget: 'Objectif de série',
      Continuous: 'consécutifs',
      Days: 'jours',
      Weeks: 'semaines',
      Months: 'mois',
      SelectTrigger: 'Sélectionner le déclencheur',
      MilestonesAndPrizes: 'Étapes et récompenses',
      TargetMake: 'Objectif : effectuer',
      ValidTransactionsEvery: 'transactions valides chaque',
      For: 'pendant',
      Level: 'Niveau',
      MustBeMoreThanLevel: 'doit être supérieur au niveau',
      SelectStreakDuration: 'Sélectionner la durée de la série',
      Daily: 'Quotidien',
      Weekly: 'Hebdomadaire',
      Monthly: 'Mensuel',
      AtLeastOneConditionIsRequired: 'Au moins une condition est requise',
      CustomerSignIn: 'Connexion client',
      TransactionCreated: 'Transaction créée',
      TargetSpend: 'Cible : Dépense',
      CurrencyEvery: 'devise chaque',
      TargetSignIn: 'Cible : Connexion',
      TimesEvery: 'fois chaque',
      Perform: 'effectuer',
      Signin: 'se connecter',
      Transaction: 'transaction',
      Spend: 'dépenser',
      PerformTheTask: 'effectuer la tâche',
      InOrderToWinThePrize: 'afin de gagner le prix',
      MakeTransactionAtLeast: 'effectuer une transaction au moins',
      Times: 'fois',
      AtLeast: 'au moins',
      Where: 'où',
      CurrencyOnTransactionsWhere: 'devise, sur les transactions où',
      MakeTransaction: 'effectuer une transaction'
    },

    LandingPage: {
      Title: "Page d'accueil",
      Headline: 'Titre',
      SubHeadline: 'Sous-titre',
      BodyText: 'Corps du texte',
      Image: 'Image',
      CTAButtonText: 'Texte du bouton CTA',
      CTAButtonColour: 'Couleur du bouton CTA',
      CTAButtonTextColour: 'Couleur du texte du bouton CTA',
      TermsAndConditions: 'Conditions générales'
    },

    StampCampaign: {
      Config: {
        Title: 'Sélectionner le nombre de tampons',
        TotalStampsOnCard: 'Total des tampons sur la carte',
        TotalStamps: 'Total des tampons',
        StampsPerRow: 'Nombre de tampons par ligne (max 5)',
        StampsPerRowPlaceholder: '(Optionnel) Spécifier les tampons par ligne',
        StampsPerColumn: 'Nombre de tampons par colonne',
        StampsPerColumnPlaceholder: '(Optionnel) Spécifier les tampons par colonne'
      },
      TriggerConfig: {
        Title: 'Définir les règles de gain des tampons'
      },
      CardBackground: {
        Title: 'Image de la carte',
        HeaderMessage: "Message d'en-tête",
        Subheadline: 'Sous-titre',
        Backgrounds: 'Arrière-plans',
        BackgroundImage: 'Image de fond',
        RemoveImage: "Supprimer l'image",
        BrowseFiles: 'PARCOURIR LES FICHIERS',
        CardBackgroundImage: 'Image de fond de la carte',
        CardBackgroundImageAlt: 'Arrière-plan de la carte de tampons',
        ThumbnailImage: 'Image miniature',
        ThumbnailImageAlt: 'Miniature du tampon',
        Elements: 'Éléments',
        GiftActive: 'Cadeau (Actif)',
        GiftActiveAlt: 'Cadeau',
        GiftInactive: 'Cadeau (Inactif)',
        GiftInactiveAlt: 'Cadeau (Inactif)',
        StampActive: 'Tampon (Actif)',
        StampActiveAlt: 'Tampon',
        StampInactive: 'Tampon (Inactif)',
        StampInactiveAlt: 'Tampon (Inactif)',
        ButtonText: 'Texte du bouton',
        ButtonExternalLink: 'Lien externe du bouton',
        ButtonColour: 'Couleur du bouton',
        ButtonTextColour: 'Couleur du texte du bouton'
      },
      LimitConfig: {
        Title: 'Limites de tampons',
        TotalStampCards: 'Total des cartes de tampons',
        TotalStampCardsPerUser: 'Total des cartes de tampons par utilisateur',
        TotalStampsPerUser: 'Total des tampons par utilisateur',
        TotalStamps: 'Total des tampons',
        Every: 'tous les',
        Days: 'Jours',
        Months: 'Mois',
        Year: 'An',
        Weeks: 'Semaines'
      }
    },

    Referral: {
      Title: 'Types de codes de parrainage',
      CodeType: 'Type de code',
      ReferredBy: 'Parrainé par',
      SelectFile: 'Sélectionner un fichier',
      SystemGenerated: 'Généré par le système',
      AlternateId: 'ID alternatif',
      User: 'Utilisateur',
      Partner: 'Partenaire',
      ActionMechanics: "Mécaniques d'action",

      UploadSingleFileFiled: {
        AcceptedFormat: 'Formats acceptés : fichiers {{acceptedFormatsString}} uniquement',
        DownloadSample: 'Télécharger un exemple',
        ChooseFile: 'Choisir un fichier'
      }
    },

    CampaignRulesTable: {
      Name: 'Nom',
      CampaignPointsIssued: 'Points de campagne émis',
      Action: 'Action',
      Edit: 'Modifier',
      Remove: 'Supprimer'
    }
  },

  [CampaignReviewPageKey]: {
    GameInfoTitle: 'Informations du jeu',

    GameInfo: {
      NumberOfTaps: 'Nombre de taps :',
      NumberOfGiftsShown: "Nombre d'icônes cadeau :",
      NumberOfGiftsToDrop: "Nombre d'icônes cadeau à faire tomber :",
      CampaignLifetimeMaxMovesAvailable: 'Limites totales de la campagne de jeu :',
      AccountLifetimeMaxMovesAvailable:
        'Les utilisateurs individuels ne peuvent jouer à ce jeu que :',
      AccountIntervalMaxMovesAvailable:
        'Les utilisateurs individuels ne peuvent jouer à ce jeu que :',
      Times: 'fois',
      Per: 'par'
    },

    CampaignRequestComment: {
      Content: 'Contenu',
      DeleteButton: 'Bouton supprimer',
      Delete: 'Supprimer',
      Time: 'Temps',

      Title: 'Campagne en attente',

      Description:
        "Cette campagne est en attente d'approbation. Tous les commentaires ajoutés apparaîtront ici.",
      CommentsAdded: 'commentaires ajoutés'
    },

    DeleteCommentModal: {
      SuccessMessage: 'Commentaire supprimé',
      ErrorMessage: 'Erreur lors de la suppression du commentaire',
      Title: 'Supprimer le commentaire ?',
      OkText: 'Supprimer',
      DescriptionLineOne: 'Êtes-vous sûr de vouloir supprimer ce commentaire ?',
      DescriptionLineTwo: 'Cette action ne peut pas être annulée.',
      CancelText: 'Annuler'
    },

    ApproveDenyCampaignRequestModalTitle: 'Approuver la campagne ?',
    ApproveDenyCampaignRequestModalButton: 'Approuver',

    ApproveDenyCampaignRequestModal: {
      SuccessMessage: 'La demande a été approuvée',
      ErrorMessage: 'Une erreur est survenue',

      ApproveTitle: 'Approuver la campagne ?',
      Title: 'Soumettre une demande de suppression ?',
      ApproveOkText: 'Approuver',
      OkText: 'Demander la suppression',
      CancelText: 'Annuler',

      ApproveDescriptionLineOne: 'Êtes-vous sûr de vouloir approuver cette campagne ?',
      ApproveDescriptionLineTwo: 'Cette action ne peut pas être annulée.',

      DescriptionLineOne:
        "Cette campagne est en attente d'approbation. Êtes-vous sûr de vouloir la supprimer ?",
      DescriptionLineTwo:
        'Une fois la suppression approuvée, cette campagne ne sera plus disponible et vous devrez la créer à nouveau.'
    },

    AddCommentModalTitle: 'Voir et ajouter des commentaires',
    AddCommentModalButton: 'Ajouter un commentaire',
    AddCommentModal: {
      SuccessMessage: 'Commentaire ajouté',
      ErrorMessage: "Erreur lors de l'ajout du commentaire",
      CancelText: 'Annuler',
      CommentInputPlaceholder: 'Saisissez votre commentaire ici',
      AddCommentButton: 'Ajouter un commentaire'
    },

    CampaignInfoTitle: 'Informations de la campagne',

    ReviewInfo: {
      Subtitle: 'Sous-titre :',
      Description: 'Description :',
      TnC: 'Conditions générales :',
      RiskDisclaimer: 'Avertissement sur les risques :',
      BranchName: 'Nom de la marque :',
      Tags: 'Tags :',
      Categories: 'Catégories :',
      Labels: 'Étiquettes :',
      Catalogue: 'Catalogues :',
      UploadImages: 'Photos téléchargées :',
      Merchant: 'Marchand :',
      CustomField: 'Champs personnalisés :',
      Type: 'Type :',
      Url: 'URL du site web :',
      Partner: 'Partenaire :',
      Reset: 'Réinitialiser :',
      Stackable: 'Cumulable :',
      Status: 'Statut :',
      Name: 'Nom de la campagne :',
      Duration: 'Durée de la campagne :',
      StepsToRedeem: 'Étapes pour échanger :',
      ActiveAt: 'Actif à :',
      Owner: 'Propriétaire :',
      RewardLegacyAudience: 'Où cette récompense peut-elle être affichée :',
      RewardsCost: 'Coût des récompenses :',
      SellingPrice: 'Prix de vente :',

      OperatingDays: "Jours d'exploitation :",
      OperatingPeriod: "Période d'exploitation :",

      ReviewMonth: 'Mois de révision :',
      PromotionSettings: 'Paramètres de promotion :',
      DemotionSettings: 'Paramètres de rétrogradation :'
    },

    SocialMediaReview: {
      CopyTextSuccessMessage: 'URL des réseaux sociaux copiée !',
      Title: 'Réseaux sociaux',
      OGTitle: 'Titre',
      OGDescription: 'Description',
      OGImage: 'Image',
      OGImageAlt: 'Aperçu réseaux sociaux',
      AlternativeIOSLinkDescription: 'Lien App iOS',
      AlternativeAndroidURLDescription: 'Lien App Android',
      OGURL: 'Lien Web',
      SocialMediaURL: 'URL réseaux sociaux',
      CopyURLButton: "Copier l'URL",
      OGURLDescription: 'Ce lien sera généré uniquement après le lancement',
      WebLink: 'Lien Web',
      Description:
        "Le champ {{webLink}} doit être rempli pour que l'URL des réseaux sociaux soit générée"
    },

    AudienceInfoTitle: "Informations sur l'audience",

    AudienceInfo: {
      Description: 'Audience sélectionnée :',
      NoListsSelected: 'Aucune liste sélectionnée',
      Include: 'Inclure',
      Exclude: 'Exclure',
      AudienceAttributes: "Attributs de l'audience",
      AudienceList: "Liste d'audience"
    },

    EnrolmentSettings: "Paramètres d'inscription",
    AutoEnrolUsers: 'Inscription automatique des utilisateurs',
    EnrollableUntil: "Inscriptible jusqu'au",
    AutoRedeemOutcome: "Résultat d'échange automatique",
    StampMechanics: 'Mécaniques de tampons',
    TotalStampCards: 'Total des cartes à tampons',
    TotalStampCardsPerUser: 'Total des cartes à tampons par utilisateur',
    TotalStamps: 'Total des tampons',
    TotalStampsPerUser: 'Total des tampons par utilisateur',

    GameMechanics: {
      Title: 'Mécaniques de jeu',
      HitThePinata: {
        Title: 'Frappez la Piñata',
        InstructionsLineOne:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en frappant la piñata.",
        InstructionsLineTwo:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        IdealFor: 'Idéal pour',
        InstructionsLineThree: '1. Jeu saisonnier',
        HeaderMessage: "Message d'en-tête",
        GameDesign: 'Design du jeu',
        PlayButtonText: 'Texte du bouton jouer'
      },

      ShakeTheTree: {
        Title: "Secouez l'arbre",
        InstructionsLineOne:
          'Engagez les clients avec un défi qui nécessite de secouer le téléphone',
        GameMechanics: 'Mécaniques de jeu',
        InstructionsLineTwo:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en frappant la piñata",
        InstructionsLineThree:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        IdealFor: 'Idéal pour',
        InstructionsLineFour: '1. Jeu saisonnier',
        HeaderMessage: "Message d'en-tête",
        GameDesign: 'Design du jeu',
        TreeVisual: "Visuel de l'arbre",
        GiftVisual: 'Visuel du cadeau',
        PlayButtonText: 'Texte du bouton jouer'
      },

      QuizOrSurveyTypeGame: {
        Properties: 'Propriétés',

        GameMeta: {
          ScratchCard: 'Carte à gratter',
          ScratchCardDetails:
            'Engagez les clients avec un défi qui nécessite de gratter une carte de jeu.',
          HitThePinata: 'Frappez la Piñata',
          HitThePinataDetails:
            'Engagez les clients avec un défi qui nécessite de secouer le téléphone.',
          ShakeTheTree: "Secouez l'arbre",
          ShakeTheTreeDetails:
            "Engagez les clients avec un défi qui nécessite de taper sur l'objet.",
          SpinTheWheel: 'Tournez la roue',
          SpinTheWheelDetails: 'Engagez le client avec une roue de la fortune.',
          Plinko: 'Plinko',
          PlinkoDetails: 'Faites tomber la balle et obtenez des rebonds chanceux'
        },

        GameGraphics: {
          AppGraphics: "Graphiques de l'application",
          PreScratch: 'pré-grattage',
          PostSuccess: 'Post (succès)',
          PostFail: 'Post (échec)',
          RewardIcon: 'Icône de récompense',
          NumberOfWedges: 'Nombre de segments',
          WedgeColors: 'Couleurs des segments',
          Wedge: 'Segment',
          WheelImage: 'Image de la roue',
          WheelPosition: 'Position de la roue',
          PointerImage: 'Image du pointeur',
          Headline: 'Titre',
          Subheadline: 'Sous-titre',
          AppBackground: "Arrière-plan de l'application",
          ButtonText: 'Texte du bouton',

          FrameColor: 'Couleur du cadre',
          BallColor: 'Couleur de la balle',
          HeadlineTextColor: 'Couleur du texte du titre',
          SubheadlineTextColour: 'Couleur du texte du sous-titre'
        },

        Survey: 'Sondage',
        SurveyDetails: 'Engagez le client avec des questions à choix multiples.',
        Quiz: 'Quiz',
        QuizDetails: 'Engagez le client avec des questions à choix multiples.',
        BackgroundImage: 'Image de fond',
        Submit: 'Soumettre'
      }
    },

    RewardLimits: {
      Title: 'Limites de récompenses',
      DescriptionLineOne: 'Nombre total de récompenses pouvant être émises :',
      DescriptionLineTwo: 'Nombre de récompenses que chaque utilisateur peut recevoir :',
      DescriptionLineThree: 'Les utilisateurs individuels ne peuvent jouer à ce jeu que :',
      DescriptionLineFour: "La campagne n'émettra des récompenses que :",
      InTotal: 'au total',
      Times: 'fois',
      Per: 'par'
    },

    Rules: 'Règles',

    RulePreview: {
      MoreOutcomes: '+{{count}} résultat(s) supplémentaire(s)',
      ID: 'ID',
      RulesBalance: 'Équilibre des règles',
      Of: 'de',
      Trigger: 'Déclencheur',
      Type: 'Type',
      Conditions: 'Conditions',
      EventName: "Nom de l'événement",
      CampaignId: 'ID de campagne',
      RewardId: 'ID de récompense',
      LoyaltyId: 'ID de fidélité',
      LoyaltyTierId: 'ID de niveau de fidélité',
      AutomationTriggerId: "ID de déclencheur d'automatisation",
      Outcome: 'Résultat',
      NumberOfStamps: 'Nombre de tampons',
      AwardPoints: 'Points attribués',
      ForEveryCurrency: 'Pour chaque devise',
      UpToAMaximumOfPoints: "Jusqu'à un maximum de points",
      UserEarnsOneRaffleTicket: "L'utilisateur gagne 1 ticket de tirage au sort",
      TheTaskWillBeMarkedAsDone: 'La tâche sera marquée comme "terminée"',
      Points: 'Points',
      LoyaltyProgram: 'Programme de fidélité',
      Award: 'Récompense',
      GlAccountNumber: 'Numéro de compte GL',
      GlAccountName: 'Nom du compte GL',
      CostCenterId: 'ID du centre de coût',
      BranchCode: "Code de l'agence",
      Reward: 'Récompense',
      Name: 'Nom',
      SellingFrom: 'Vente à partir de',
      Limits: 'Limites',
      MaximumEvents: 'Événements maximum',
      PerCampaign: 'par campagne',
      PerUser: 'par utilisateur',
      TriggerRateLimit: 'Limite de taux de déclenchement',
      PerUserForEvery: 'par utilisateur pour chaque',
      StreakCampaignMechanics: 'Mécanique de campagne en série',
      StreakTarget: 'Objectif de série',
      StreakPeriod: 'Période de série',
      UserMustPerform: "L'utilisateur doit effectuer",
      UserMust: "L'utilisateur doit",
      TargetCriteria: 'Critères de l’objectif',
      AtLeast: 'au moins',
      Within: 'dans',
      CurrencyWithin1: 'devise dans 1',
      TimesWithin1: 'fois dans 1',
      TransactionsWithin: 'transactions dans'
    },

    ActionMechanics: "Mécaniques d'action",

    InstantRewardMechanics: 'Mécaniques de récompense instantanée',
    InstantRewardMechanicsLabel:
      "Afficher la campagne dans la liste des campagnes de l'utilisateur ?",
    IssuanceLimits: "Limites d'émission",
    IssuanceLimitsLabel: "Nombre total d'événements d'émission de prix (au niveau de la campagne)",
    AccountLifetimeMaxAvailableLabel:
      "Nombre total d'événements d'émission de prix (par utilisateur)",
    RateLimitCampaignLabel: 'Limite de taux (au niveau de la campagne)',
    RateLimitUserLabel: 'Limite de taux (par utilisateur)',
    Outcomes: 'Résultats',
    IssuePrizeEvents: "événement(s) d'émission de prix",
    LimitTo: 'Limiter à',
    ForEvery: 'pour chaque',

    PrizeSet: {
      Outcomes: 'résultats',
      QuizSelectableOne: 'Attribuer des prix pour avoir terminé le quiz',
      QuizSelectableTwo: 'Attribuer des points par réponse correcte',
      PointsPerAnswerLabel: 'Points par réponse correcte :',
      Points: 'points',
      Edit: 'Modifier',
      Remove: 'Supprimer',
      NoPrizeAdded: 'Aucun prix ajouté',
      Prizes: 'Prix',
      AddRandomPrize: 'Ajouter un prix aléatoire',
      AddPrizeSet: 'Ajouter un ensemble de prix',
      AddRewards: 'Ajouter des récompenses',
      AwardPoints: 'Attribuer des points',
      AwardBadges: 'Attribuer des badges',
      AddPrize: 'Ajouter un prix',
      IncludeNoPrizeAsOutcome: 'Inclure aucun prix comme résultat',

      GLACDetail: 'Détail du compte GL',
      GLACNo: 'N° de compte GL',
      GLACName: 'Nom du compte GL',
      CostCenterID: 'ID du centre de coût',
      BranchCode: "Code de l'agence",

      WinOdds: 'Probabilité de gain',
      Prize: 'Prix',
      Merchant: 'Marchand',
      Balance: 'Solde'
    },

    PrizePerAnswer: {
      CountOfPointsValidationMessage: 'Veuillez spécifier un nombre de points par réponse',
      LoyaltyProgramValidationMessage: 'Veuillez sélectionner un programme de fidélité',
      Title: 'Points par réponse correcte',
      OkText: 'Enregistrer',
      CancelText: 'Annuler',
      LoyaltyProgramLabel: 'Sélectionner un programme de fidélité',
      LoyaltyProgramSelectPlaceholder: 'Sélectionner un programme de fidélité',
      CountOfPointsLabel: 'Attribuer'
    },

    RewardSelectModal: {
      Title: 'Sélectionner une récompense',
      OkText: 'Ajouter une récompense',
      CancelText: 'Annuler',
      SearchPlaceholder: 'Trouver une récompense par nom, id ou marchand',
      ID: 'ID',

      Tabs: {
        All: 'Tout',
        Active: 'Actif',
        Approved: 'Approuvé',
        Private: 'Privé',
        System: 'Système'
      },

      Reward: 'Récompense',
      Merchant: 'Marchand',
      Balance: 'Solde',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à"
    },

    IssuePointsModal: {
      ShowVariablePointsValidationMessage: 'Veuillez spécifier un nombre de points',
      LoyaltyProgramValidationMessage: 'Veuillez spécifier un programme de fidélité',
      ShowVariablePointsOutcomeValidatioMessage: 'Ce champ est obligatoire',
      GLAccountTypeValidationMessage: 'Veuillez sélectionner un type de compte GL',
      GLAccountNameValidationMessage: 'Veuillez sélectionner un nom de compte GL',
      GLAccountIDValidationMessage: 'Veuillez sélectionner un compte GL',

      FixedPoints: 'Points fixes',
      VariablePoints: 'Points variables',

      IssuePoints: 'Émettre des points',
      Save: 'Enregistrer',
      Cancel: 'Annuler',
      SelectLoyaltyProgramLabel: 'Sélectionner un programme de fidélité',
      ShowVariablePointsAlertMessage:
        "Vous pouvez attribuer soit des points fixes, soit des points variables. Pour les points variables, la dernière transaction de l'utilisateur sera prise en compte.",
      NumberOfPointsToAward: 'Nombre de points à attribuer',
      NumberOfPointsToAwardPlaceholder: 'ex. 10',
      SelectGLAccount: 'Sélectionner un compte GL',
      SelectGLAccountPlaceholder: 'Sélectionner un compte GL',
      GLAccountType: 'Type de compte GL',
      GLAccountTypePlaceholder: 'Type de compte GL',
      GLAccountName: 'Nom du compte GL',
      GLAccountNamePlaceholder: 'Nom du compte GL'
    },

    VariablePointsPane: {
      Transaction: 'Transaction',
      Award: 'Attribuer',
      Every: 'Chaque',
      UpToAMaximumAmountOf: "Jusqu'à un montant maximum de"
    },

    BadgeSelectModal: {
      Title: 'Sélectionner un badge à afficher',
      OkText: 'Ajouter un badge',
      CancelText: 'Annuler'
    },

    BadgeListTable: {
      Name: 'Nom',
      StartDate: 'Date de début',
      EndDate: 'Date de fin',
      Actions: 'Actions',
      ID: 'ID',
      SearchBadgesPlaceholder: 'Rechercher des badges',
      Edit: 'Modifier',
      Deactivate: 'Désactiver',
      Activate: 'Activer',
      ErrorSortingBadgeMessage: 'Erreur lors du tri du badge.',
      ErrorUpdatingBadgeStateMessage: "Erreur lors de la mise à jour de l'état du badge",
      Status: 'Statut'
    },

    ReviewOutcomesDisplay: {
      IncludeNoOutcome: 'Inclure aucun résultat',
      All: 'Tout',
      Active: 'Actif',
      Approved: 'Approuvé',
      Inactive: 'Inactif',
      Ended: 'Terminé',
      Private: 'Privé',
      Points: 'Points',
      Custom: 'Personnalisé'
    },

    StampCampaignOutcomes: {
      GLAccountNo: 'N° de compte GL',
      GLAccountName: 'Nom du compte GL',
      CostCenterID: 'ID du centre de coût',
      GLAccountDetail: 'Détail du compte GL',

      Slot: 'Emplacement',
      OutcomeType: 'Type de résultat',
      AddRewards: 'Ajouter des récompenses',
      AwardPoints: 'Attribuer des points',
      AwardBadges: 'Attribuer des badges',
      AddPrizeToSet: "Ajouter un prix à l'ensemble",
      IncludeNoPrizeAsOutcome: 'Inclure aucun prix comme résultat',
      AddAnotherReward: 'Ajouter une autre récompense',
      AddAnotherBadge: 'Ajouter un autre badge',
      RewardName: 'Nom de la récompense',
      NumberOfPoints: 'Nombre de points',
      ID: 'ID',
      Reward: 'Récompense',
      Action: 'Action',
      Delete: 'Supprimer',
      NoOutcome: 'Aucun résultat',
      ChangeByAddingReward: 'modifier en ajoutant une récompense',
      AddFixedPrizeSet: 'Ajouter un ensemble de prix fixe',
      AddRandomPrize: 'Ajouter un prix aléatoire',
      IssueReward: 'Émettre une récompense',
      IssuePoints: 'Émettre des points',
      IssueBadges: 'Émettre des badges',
      AwardGameTry: 'Attribuer des tentatives de jeu',
      SlotsWithOutcomeAdded: 'Emplacements avec résultat ajouté'
    },

    OutcomeSettings: {
      Title: 'Paramètres des résultats',
      PrizeSet: 'Ensemble de prix',
      Submit: 'Soumettre',
      MixedRewardsButtonText: 'Texte du bouton basé sur la première récompense listée',
      Headline: 'Titre'
    },

    GameOutcomeScreens: {
      QuizScreens: 'Écrans du quiz',
      SurveyScreens: 'Écrans du sondage',
      LandingPage: "Page d'accueil",
      LandingScreenHeading: "Titre de l'écran d'accueil",
      LandingScreenSubheading: "Sous-titre de l'écran d'accueil",
      LandingScreenButtonText: "Texte du bouton de l'écran d'accueil",
      LandingScreenText: "Texte de l'écran d'accueil",
      OutcomeScreen: 'Écran des résultats',
      SuccessfulOutcomeMessage: 'message de résultat réussi',
      SuccessfulOutcomeButton: 'bouton de résultat réussi',
      NoOutcomeMessage: 'message sans résultat',
      NoOutcomeButton: 'bouton sans résultat',
      OutcomeScreens: 'Écrans des résultats',
      WinRewardGraphic: 'Graphique de récompense gagnée',
      WinRewardMessage: 'Message de récompense gagnée',
      WinRewardButton: 'Bouton de récompense gagnée'
    },

    TeamMechanics: "Mécaniques d'équipe",
    MemberPerTeam: 'Membre par équipe',
    DisplaySetup: "Configuration de l'affichage",
    LandingPage: "Page d'accueil",
    PreEnrolmentMessage: 'Message pré-inscription',
    StampsEarnMessage: 'Message de gain de tampons',
    JoinTeamPagePreview: {
      Title: 'Rejoindre une équipe',
      ButtonText: "Rejoindre l'équipe",
      InputPlaceholder: "Code d'équipe"
    },
    JoinTeamPage: "Page pour rejoindre l'équipe",
    JoinTeamInfoMessage: "Message d'information pour rejoindre l'équipe",
    InviteMemberMessage: "Message d'invitation de membre",
    InviteMemberMessageDescription: "Description du message d'invitation de membre",
    InviteMemberMessageBlurb: "Texte du message d'invitation de membre",

    QuestMechanics: 'Mécaniques de quête',
    UserTriesValidity: 'Validité des essais utilisateur',
    Task: 'Tâche',
    QuestTask: {
      AddRule: 'Ajouter une règle',
      Required: '*obligatoire'
    },
    TotalQuests: 'Nombre total de quêtes pouvant être démarrées dans une campagne',
    TotalQuestsPerUser: 'Nombre total de quêtes pouvant être démarrées par chaque utilisateur',
    DisplaySetItup: "Configurer l'affichage",

    CampaignRuleFormModal: {
      ValidationMessages: {
        PleaseSelectATriggerEvent: 'Veuillez sélectionner un événement déclencheur',
        PleaseSelectALoyaltyProgramValue:
          'Veuillez sélectionner une valeur de programme de fidélité',
        PleaseSelectALoyaltyTierValue: 'Veuillez sélectionner un niveau de fidélité',
        PleaseSelectACampaign: 'Veuillez sélectionner une campagne',
        PleaseSelectAStampCampaign: 'Veuillez sélectionner une campagne de tampons',
        PleaseEnterTheNumberOfStamps: 'Veuillez saisir le nombre de tampons',
        NumberOfStampsMustBeAtLeastOne: 'Le nombre de tampons doit être au moins 1',
        StampPositionMustBeAtLeastOne: 'La position du tampon doit être au moins 1',
        PleaseEnterTheStampPosition: 'Veuillez saisir la position du tampon',
        PleaseSelectAnAutomationTrigger: 'Veuillez sélectionner un déclencheur d’automatisation',
        IntervalCannotBeLessThanZero: "L'intervalle ne peut pas être inférieur à zéro",
        IntervalCannotBeGreaterThan365: "L'intervalle ne peut pas être supérieur à 365",
        PleaseEnterTheInterval: "Veuillez saisir l'intervalle",
        PleaseSelectAMilestone: 'Veuillez sélectionner une étape',
        PleaseSelectARule: 'Veuillez sélectionner une règle',
        PleaseSelectAReward: 'Veuillez sélectionner une récompense',
        ThisFieldIsRequired: 'Ce champ est requis',
        TheFieldIsRequired: 'Le champ est requis',

        AttributeIsRequired: "L'attribut est requis",
        OperatorIsRequired: "L'opérateur est requis",
        PleaseSelectAtLeastOneDay: 'Veuillez sélectionner au moins un jour',
        PleaseSelectATime: 'Veuillez sélectionner une heure',
        FromTimeMustBeLessThanToTime: "L'heure de début doit être inférieure à l'heure de fin",
        PleaseSelectAFormTime: 'Veuillez sélectionner une heure de début',
        PleaseSelectAnToTime: 'Veuillez sélectionner une heure de fin',
        PleaseConfigureTheRuleTriggerDays:
          'Veuillez configurer les jours de déclenchement de la règle',

        PleaseConfigureTheTrigger: 'Veuillez configurer le déclencheur',
        PleaseFillInTheNameOfTheRule: 'Veuillez renseigner le nom de la règle',
        PleaseSelectAnOwner: 'Veuillez sélectionner un propriétaire',
        PleaseSelectATriggerRule: 'Veuillez sélectionner une règle de déclenchement',
        PleaseSpecifyAStartTime: 'Veuillez spécifier une heure de début',
        PleaseSpecifyAValidEndTime: 'Veuillez spécifier une heure de fin valide',
        PleaseSelectAnOutcomeType: 'Veuillez sélectionner un type de résultat',
        PleaseSelectAMediaTag: 'Veuillez sélectionner une étiquette média',
        PleaseSelectAGLAccountType: 'Veuillez sélectionner un type de compte GL',
        PleaseSelectAGLAccountName: 'Veuillez sélectionner un nom de compte GL',
        GLAccountIDIsRequired: "L'identifiant du compte GL est requis",
        PleaseEnterAKey: 'Veuillez saisir une clé',
        AtLeastOneOutcomePropertyIsRequired: 'Au moins une propriété de résultat est requise',
        OutcomePropertiesAreRequired: 'Les propriétés de résultat sont requises',
        ValueMustBeGreaterThanZero: 'La valeur doit être supérieure à zéro.',
        ValueCannotBeZero: 'La valeur ne peut pas être zéro.',
        PleaseEnterANumber: 'Veuillez saisir un nombre',
        PleaseEnterAWholeNumber: 'Veuillez saisir un nombre entier',
        NumberMustBeAPositiveNumber: 'Le nombre doit être un nombre positif',

        OutcomeRequiredErrorMessage: 'Ce champ est requis',
        OutcomePointsRequiredErrorMessage: 'Veuillez sélectionner un programme de fidélité'
      },
      Title: 'Règle de campagne',
      RuleName: 'Nom de la règle',
      Priority: 'Priorité',
      Outcome: 'Résultat',
      Edit: 'Modifier',
      Create: 'Créer',
      Update: 'Mettre à jour',
      Add: 'Ajouter',
      CancelText: 'Annuler',
      RequiredErrorMessage: 'Ce champ est obligatoire.',
      OutcomeRewardRequiredErrorMessage: 'Veuillez sélectionner une récompense',
      OutcomePointsRequiredErrorMessage: 'Veuillez sélectionner un programme de fidélité',
      GLAccountTypeRequiredErrorMessage: 'Veuillez sélectionner un type de compte GL',
      GLAccountNameRequiredErrorMessage: 'Veuillez sélectionner un nom de compte GL',
      OutcomeRequiredErrorMessage: 'Ce champ est obligatoire',
      StampsWillBeIssued: 'Le(s) tampon(s) sera/seront émis',
      FixedPoints: 'Points fixes',
      VariablePoints: 'Points variables',
      EarnType: 'Type de gain',
      Award: 'RÉCOMPENSE',
      Points: 'points',
      ForEvery: 'POUR CHAQUE',
      Currency: 'Devise',
      UpToAMaximumOf: "JUSQU'À UN MAXIMUM DE",
      QuestOutcomeSegment: 'La tâche sera marquée comme "terminée"',
      InviteOutcomeSegment: 'La tâche sera marquée comme "terminée"',
      RaffleOutcomeSegment: "L'utilisateur gagnera un ticket de tombola",
      SelectOutcomeType: 'Sélectionner le type de résultat',
      Reward: 'Récompense',
      ChangeReward: 'Modifier la récompense',
      SelectReward: 'Sélectionner une récompense',
      SelectLoyaltyProgram: 'Sélectionner un programme de fidélité',
      NumberOfPoints: 'Nombre de points',
      SelectGLAccount: 'Sélectionner un compte GL',
      GLAccountType: 'Type de compte GL',
      GLAccountTypePlaceholder: 'type',
      GLAccountName: 'Nom du compte GL',
      GLAccountNamePlaceholder: 'nom'
    },

    SelectTriggerSection: {
      SelectATrigger: 'Sélectionner un déclencheur',
      Custom: 'Personnalisé',
      Transaction: 'Transaction',
      Loyalty: 'Fidélité',
      Campaign: 'Campagne',
      Customer: 'Client',
      Reward: 'Récompense',
      Location: 'Localisation',
      SelectTrigger: 'Sélectionner un déclencheur',
      SelectATriggerPlaceholder: 'Veuillez sélectionner un déclencheur',
      Others: 'Personnalisé',
      LoyaltyTrigger: {
        HelpText:
          "Le nombre de points sur le point d'expirer sera vérifié au début de chaque cycle de révision.",
        AchievedNextTier: 'Niveau suivant atteint',
        TenPercentCloseToNextTier: '10% proche du niveau suivant',
        PointsIssued: 'Points émis',
        AgeingPoints: "Points vieillissants (points sur le point d'expirer dans le cycle actuel)",
        SelectLoyaltyProgram: 'Sélectionner un programme de fidélité',
        SelectNextTier: 'Sélectionner le niveau suivant',
        SelectNextTierPlaceholder: 'Veuillez sélectionner un niveau de fidélité'
      },
      RewardTrigger: {
        RedeemReward: 'Échanger une récompense',
        IssueReward: 'Émettre une récompense',
        IssueRewardFromCampaign: 'Émettre une récompense depuis la campagne',
        IssueRewardFromMerchant: 'Émettre une récompense depuis le marchand',
        VoucherForParticularRewardExpiringIn: 'Bon pour une récompense particulière expirant dans',
        AnyVoucherExpiringIn: 'Tout bon expirant dans {{days}}'
      },

      MilestoneTrigger: {
        StampRedeemed: 'Tampon échangé',
        StampsIssued: 'Tampons émis',
        StampsInactive: 'Tampons inactifs',
        GamePlayed: 'Jeu joué',
        GameTryIssued: 'Essai de jeu émis',
        CampaignEnrolled: 'Inscrit à la campagne',
        CampaignCompleted: 'Campagne terminée',
        CampaignNotCompleted: 'Campagne non terminée',
        ProgressLevelAchieved: 'Niveau de progression atteint',
        ProgressRuleTriggered: 'Règle de progression déclenchée',
        QuestTaskCompleted: 'Tâche de quête terminée',

        SelectAStampCampaign: 'Sélectionner une campagne de tampons',
        Change: 'Modifier',
        Select: 'Sélectionner',
        Stamp: 'Tampon',
        Campaign: 'Campagne',
        ID: 'ID',
        FooterMsg:
          'Toute récompense {{isCampaignRewardsSelected}} dans cette campagne sera un déclencheur',
        SelectStampsSlot: 'Sélectionner un emplacement de tampons',
        StampCardPosition: 'Position de la carte de tampons'
      },

      CustomerTrigger: {
        SignUp: 'Inscription',
        SignIn: 'Connexion',
        ProfileUpdated: 'Profil mis à jour'
      },

      TransactionTrigger: {
        SelectATriggerPlaceholder: 'Choisir un...',
        FromDate: 'Date de début',
        ToDate: 'Date de fin',
        SelectOperator: 'Sélectionner un opérateur',
        PropertyDataType: 'Type de données de propriété',
        Key: 'Clé',
        Operator: 'Opérateur',
        Sunday: 'Dimanche',
        Monday: 'Lundi',
        Tuesday: 'Mardi',
        Wednesday: 'Mercredi',
        Thursday: 'Jeudi',
        Friday: 'Vendredi',
        Saturday: 'Samedi',
        Value: 'Valeur',
        PleaseSeparateMultipleValuesUsingComma:
          'Veuillez séparer les valeurs multiples par des virgules',
        SelectTrigger: 'Sélectionner un déclencheur',
        And: 'Et',
        AddCondition: 'Ajouter une condition'
      },

      LocationTrigger: {
        EnterLocationDetails: 'Saisir les détails de localisation',
        Latitude: 'Latitude',
        Longitude: 'Longitude',
        LatitudeDegrees: 'Degrés (-90.0 à 90.0)',
        LongitudeDegrees: 'Degrés (-180.0 à 180.0)',
        PermissibleRadius: 'Rayon autorisé (en mètres)',
        Radius: 'Rayon autorisé',
        Preview: 'APERÇU'
      },

      CampaignSelectField: {
        Interval: 'Intervalle',
        Days: '(Jours)',
        SelectAStampCampaign: 'Sélectionner une campagne de tampons',
        Change: 'Modifier',
        Select: 'Sélectionner',
        Stamp: 'Tampon',
        SelectACampaign: 'Sélectionner une campagne',
        Edit: 'Modifier',
        Add: 'Ajouter',
        Campaign: 'Campagne',
        SelectAMilestone: 'Sélectionner une étape',
        SelectARule: 'Sélectionner une règle',
        SelectATask: 'Sélectionner une tâche'
      },

      GameSelectField: {
        SelectAGameCampaign: 'Sélectionner une campagne de jeu',
        Game: 'Jeu',
        Campaign: 'Campagne',
        Change: 'Modifier',
        Select: 'Sélectionner'
      },

      CampaignRewardSelectField: {
        SelectACampaign: 'Sélectionner une campagne',
        Change: 'Modifier',
        Select: 'Sélectionner',
        Campaign: 'Campagne',
        SelectAReward: 'Sélectionner une récompense (Optionnel)',
        Reward: 'Récompense'
      },

      MerchantRewardSelectField: {
        SelectAMerchant: 'Sélectionner un marchand',
        Change: 'Modifier',
        Select: 'Sélectionner',
        Merchant: 'Marchand',
        AddMerchant: 'Ajouter un marchand',
        Cancel: 'Annuler',
        SearchMerchant: 'Rechercher un marchand par nom ou ID',
        Active: 'Actif',
        Inactive: 'Inactif'
      },

      RewardSelectField: {
        SelectAReward: 'Sélectionner une récompense (Optionnel)',
        Change: 'Modifier',
        Reward: 'Récompense',
        Select: 'Sélectionner',
        WarningText:
          "Le type de résultat est limité à [Push Event] lorsqu'une récompense système est sélectionnée"
      },

      RewardExpirySetupField: {
        SelectAReward: 'Sélectionner une récompense',
        Change: 'Modifier',
        Select: 'Sélectionner',
        Reward: 'Récompense',
        Periods: 'Périodes (Jours)'
      }
    },

    RuleTriggerLimitSegment: {
      Title: 'Limites de déclenchement :',
      TotalTriggerEvents: "Nombre total d'événements de déclenchement (au niveau de la campagne)",
      TotalTriggerEventsPerUser: "Nombre total d'événements de déclenchement (par utilisateur)",
      TriggerRateLimitPerUser: 'Limite de taux de déclenchement (par utilisateur)',
      LeaveTheLimitFieldsBlankForUnlimitedTriggerEvents:
        '- Laissez les champs de limite vides pour des événements de déclenchement illimités -',
      Days: 'Jours',
      Weeks: 'Semaines',
      Months: 'Mois',
      Years: 'Années',
      TriggerEventForEvery: 'événement(s) de déclenchement^ pour chaque',
      AccountIntervalLimitPlaceholder: 'ex. 2',
      AccountIntervalUnitsPlaceholder: 'ex. 1',
      TriggerLimitPlaceholder: '∞',
      TriggerAccountLimitPlaceholder: '∞',
      LimitTo: 'Limiter à'
    },

    RuleAudience: {
      SelectFilters: 'Sélectionner des filtres',
      Age: 'Âge',
      Gender: 'Genre',
      Location: 'Localisation',
      Language: 'Langue',
      Device: 'Appareil',
      Browser: 'Navigateur',
      Customs: 'Personnalisés',
      Ethnicity: 'Ethnicité',
      Loyalty: 'Fidélité',
      EmailTags: "Tags d'email",
      BirthMonth: 'Mois de naissance',
      NoFiltersSelected: 'Aucun filtre sélectionné',
      SelectedFilters: 'Filtres sélectionnés'
    },

    LoyaltyTier: {
      Includes: 'inclut',
      UsersWhoAchieved: 'Utilisateurs qui ont atteint',
      SelectProgramAndTier: 'Sélectionner le programme et le niveau'
    },

    LevelsAndPrizes: 'Niveaux et prix',

    LevelWrapper: {
      ValidatePointHelpMessage:
        'Les points du niveau {{level}} doivent être supérieurs aux points du niveau {{previousLevel}} !',
      LevelTitle: 'Affichage du niveau {{level}}',
      TotalCampaignPointsRequired: 'Total des points de campagne requis pour compléter ce niveau :'
    },

    ClaimPrizePopUp: 'Pop-up "Réclamer le prix"',

    LandingPagePreview: {
      CampaignName: 'Nom de la campagne',
      Description: 'Description',
      TermsAndConditions: 'Conditions générales',
      PRIZE: 'PRIX',
      PrizeSet: 'Ensemble de prix',
      StartPlaying: 'Commencer à jouer'
    },

    EnrolmentPage: "Page d'inscription",

    RuleGroupLandingPagePreview: {
      CampaignName: 'Nom de la campagne',
      EnrollText: "S'INSCRIRE",
      EnrollNow: "S'inscrire maintenant",
      TermsAndConditions: 'Conditions générales'
    },

    RaffleReview: {
      DisplaySettings: "Paramètres d'affichage",
      LandingPage: "Page d'accueil",
      RaffleTicket: 'Ticket de tirage au sort',
      GrandPrize: 'Grand prix',
      GrandPrizes: 'Grands prix'
    },

    DrawSection: {
      RaffleDraw: 'Tirage au sort',
      DownloadCSV: 'Télécharger CSV',
      GenerateRaffleWinners: 'Générer les gagnants du tirage',
      SomethingWentWrong: 'Une erreur est survenue',
      RaffleCampaignPending:
        'La campagne de tirage au sort est terminée. Cliquez sur "Générer les gagnants du tirage" pour déclencher le tirage et attribuer automatiquement les prix aux gagnants. Vous pourrez voir la liste des gagnants une fois le tirage terminé.',
      RaffleCampaignSuccess: 'Le tirage est terminé et les gagnants ont reçu les grands prix.'
    },

    GenerateWinnerModal: {
      GeneratingRaffleWinners: 'Génération des gagnants du tirage...'
    },

    RaffleWinnersTable: {
      Position: 'Position',
      FirstName: 'Prénom',
      LastName: 'Nom',
      CustomerID: 'ID client',
      TicketCode: 'Code du ticket',
      GrandPrize: 'Grand prix',
      PrizeSet: 'Ensemble de prix',
      ErrorFetchingWinnersList: 'Erreur lors de la récupération de la liste des gagnants'
    },

    ConfigureRaffleCodesReview: {
      ConfigureRaffleCodes: 'Configurer les codes de tirage',
      CodeGenerationMethod: 'Méthode de génération de code',
      TicketCodePrefix: 'Préfixe du code de ticket',
      LengthOfCode: 'Longueur du code',
      TotalPermutations: 'Total des permutations',
      VoucherCodeFormat: 'Format du code de bon',
      VoucherCodeLength: 'Longueur du code de bon',
      NumberOfTickets: 'Nombre de tickets',
      CodeFormat: 'Format du code'
    },

    RewardAddedTable: {
      Order: 'Ordre',
      Probability: 'Probabilité',
      Name: 'Nom',
      Value: 'Valeur',
      Operators: 'Opérateurs',
      RuleName: 'Nom de la règle',
      NoOutcome: 'Aucun résultat',
      AwardPoints: 'Points attribués',
      Merchant: 'Marchand',
      ID: 'ID',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à",
      RewardBalance: 'Solde de récompense',
      PointsAwarded: 'Points attribués',
      ReferrerLimits: 'Limites du parrain',
      RefferalsNeeded: 'Parrainages nécessaires',
      ReffererRewardLimit: 'Limite de récompense du filleul',
      RefereeLimits: 'Limites du filleul',
      GLACNo: 'N° de compte GL',
      GLACName: 'Nom du compte GL',
      CostCenterID: 'ID du centre de coût',
      BranchCode: "Code de l'agence",
      GLAccountDetail: 'Détail du compte GL'
    },

    QuizQuestionsReview: {
      Questions: 'Questions',
      Type: 'Type',
      TextQuestion: 'Question texte',
      ImageQuestion: 'Question image',
      WrittenResponse: 'Réponse écrite',
      MultipleAnswers: 'Réponses multiples',
      SingleAnswer: 'Réponse unique',
      Question: 'Question',
      Required: 'Obligatoire',
      Yes: 'Oui',
      No: 'Non'
    },

    QuestRuleTable: {
      ID: 'ID',
      Name: 'Nom',
      Status: 'Statut',
      Action: 'Action',
      Edit: 'Modifier',
      Remove: 'Supprimer'
    },

    BulkActionModal: {
      FileUploadedIsSubmittedForApproval: "Le fichier téléchargé est soumis à l'approbation",
      FileUploaded: 'Fichier téléchargé',
      ErrorUploadingFile: 'Erreur lors du téléchargement du fichier.',
      Cancel: 'Annuler',
      Upload: 'Télécharger',
      BulkUpload: 'Téléchargement en masse',
      ChooseOne: 'Choisissez-en un...',
      Campaign: 'Campagne',
      PleaseSelectACampaign: 'Veuillez sélectionner une campagne',
      LoyaltyProgram: 'Programme de fidélité',
      PleaseSelectALoyaltyProgram: 'Veuillez sélectionner un programme de fidélité',
      ClickOrDragFileToThisAreaToUpload:
        'Cliquez ou faites glisser un fichier dans cette zone pour le télécharger',
      DownloadSample: 'Télécharger un exemple',
      ActionType: "Type d'action",
      AcceptedFormatXlsxOrCsvFilesOnly: 'Format accepté : fichiers .xlsx ou .csv uniquement',
      AcceptedFormatTxtXlsxOrCsvFilesOnly:
        'Format accepté : fichiers .txt, .xlsx ou .csv uniquement'
    }
  },

  [ReferralRewardModeKey]: {
    Label: 'Type de récompense de parrainage',
    Fixed: 'Récompense de parrainage fixe',
    TierBased: 'Récompense de parrainage par paliers'
  },

  [ReferralTierLadderKey]: {
    AddTier: 'Ajouter un palier',
    RemoveTier: 'Supprimer le palier',
    EditTier: 'Modifier le palier',
    Threshold: 'Seuil du nombre de parrainages',
    TierOutcome: 'Résultat du palier',
    TierDisplaySettings: "Paramètres d'affichage du palier",
    TierTitle: 'Titre du palier',
    TierSubtitle: 'Sous-titre du palier',
    TierIcon: 'Icône du palier',
    UploadCustomIcon: 'Télécharger une icône personnalisée',
    RefereeOutcome: 'Résultat du filleul',
    EmptyState: 'Aucun palier configuré. Ajouter un palier pour commencer.',
    DuplicateThreshold: 'Un autre palier a le même seuil',
    GameTry: 'Essai de jeu',
    CurrentTier: 'Palier actuel',
    NextTier: 'Palier suivant',
    Voucher: 'Bon',
    Points: 'Points',
    Badge: 'Insigne',
    OutcomeType: 'Type de résultat',
    Save: 'Enregistrer',
    Cancel: 'Annuler',
    MissingThreshold: 'Le seuil est requis',
    MinThresholdError: 'Le seuil doit être au moins 1',
    Rule: 'Règle',
    Actions: 'Actions',
    RuleConfigured: 'Règle configurée',
    Title: 'Échelle de paliers',
    ReferralsRequired: 'parrainages requis',
    MechanicsTitle: 'Mécanique des paliers de parrainage',
    TierName: 'Palier',
    ThresholdInline: 'NOMBRE TOTAL DE PARRAINAGES REQUIS POUR COMPLÉTER CE PALIER',
    AddRule: 'Ajouter une règle',
    RuleName: 'Nom',
    Prize: 'Prix',
    AddPrize: 'Ajouter un prix',
    AddRewards: 'Ajouter des récompenses',
    AddPoints: 'Ajouter des points',
    AddBadge: 'Ajouter un insigne',
    AddGameTry: 'Ajouter un essai de jeu',
    NoData: 'Aucune donnée',
    NoPrizes: 'Aucun prix ajouté',
    TierHeadline: 'En-tête du palier',
    TierSubHeadline: 'Sous-en-tête du palier',
    RewardBalance: 'Solde de récompense',
    PointsAwarded: 'Points attribués',
    ReferrerLimits: 'Limites du parrain',
    ReferralsNeeded: 'Parrainages nécessaires',
    RefereeRewardLimit: 'Limite de récompense du filleul'
  },

  [ReferralReportsKey]: {
    InviteEarnSummary: 'Résumé Inviter & Gagner',
    InviteEarnBreakdown: 'Détail Inviter & Gagner',
    AggregatedReferralCountSummary: 'Résumé du nombre de parrainages agrégé',
    AggregatedReferralCountBreakdown: 'Détail du nombre de parrainages agrégé'
  },

  [ReferralAnalyticsKey]: {
    ReferralPerformance: 'Performance de parrainage',
    TotalReferrers: 'Total des parrains',
    TotalReferees: 'Total des filleuls',
    TotalSuccessfulReferrals: 'Total des parrainages réussis',
    ReferralCompletionRate: 'Taux de complétion des parrainages',
    CustomerEngagementRate: "Taux d'engagement client",
    ReferrersPerTier: 'Parrains par palier',
    OutcomesIssued: 'Résultats émis',
    TierColumn: 'Palier',
    ReferrersColumn: 'Parrains',
    RefereesColumn: 'Filleuls',
    KeyMetrics: 'Indicateurs clés',
    TotalSuccessfulReferralsHelp:
      'Nombre total de parrainages ayant accompli toutes les actions qualifiantes.',
    ReferralCompletionRateHelp: 'Pourcentage de parrainages démarrés qui ont été menés à terme.',
    CustomerEngagementRateHelp:
      "Pourcentage de l'audience touchée qui a interagi avec la campagne de parrainage."
  }
};
